const ITEMS = [
  "Zero sponsored bias",
  "Verified buyer feedback",
  "No marketing fluff",
  "Curated household",
  "Everyday clothing",
  "Gadgets",
  "High-end finds",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden bg-charcoal text-parchment py-3 border-y border-black/20"
    aria-hidden="true"
  >
    <div className="marquee-track flex whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em]">
      {[0, 1].map((half) => (
        <div key={half} className="flex shrink-0">
          {ITEMS.map((item) => (
            <span key={`${half}-${item}`} className="flex items-center">
              <span className="px-6">{item}</span>
              <span className="text-brass">•</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
